import RoomManagementIndexVue from "@/views/room-management/RoomManagementIndex.vue";

const roomManagement = [
  {
    path: "/roommanagement",
    name: "roommanagement",
    component: RoomManagementIndexVue,
    meta: {
      layout: "default",
      role: ["superadmin","backoffice","receptionist","supervisor"],
      public: false,
    },
  },
];

export default roomManagement;
